export default "import requests\n\nheaders = {'api_key': '{{apiKey}}'}\n\nr = requests.get('{{url}}', headers=headers)\nprint(r.json())\n"